
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 130.526 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Polygon 112","d":"M80.76 61a20 20 0 01-30.994 0l-23.14-28.357A20 20 0 0142.126 0h46.273a20 20 0 0115.5 32.643z"}})])
          )
        }
      }
    